import hooks from './shipment-invoice-stats.hooks';

export default (app) => {
  const service = app.service('api/shipment-invoice-stats');
  service.hooks(hooks);
};
